import { render, staticRenderFns } from "./PageBIEmitterPerformance.vue?vue&type=template&id=22f516a0"
import script from "./PageBIEmitterPerformance.vue?vue&type=script&lang=js"
export * from "./PageBIEmitterPerformance.vue?vue&type=script&lang=js"
import style0 from "./PageBIEmitterPerformance.vue?vue&type=style&index=0&id=22f516a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports